module.exports = __webpack_public_path__ + "img/pcx-bg-mobile.cb8f4851.svg";